module.exports = __webpack_public_path__ + "img/falls-goal-slide4.b966cdc1.gif";